import { ShiftPlanningFilters } from './use-shift-planning-page.types';
import { useExternalParams } from '../../../../../../shared/hooks/use-external-params';
import { FilledStatus } from '../../../../../../shared/components/filters/inputs/filled-status/filter-filled-status.types';

const initialValues = {
  fromDate: {
    initialValue: undefined,
    type: 'date',
  },
  company: {
    initialValue: undefined,
    type: 'string',
  },
  branchOffices: {
    initialValue: undefined,
    type: 'string_array',
  },
  departments: {
    initialValue: undefined,
    type: 'string_array',
  },
  filledStatus: {
    initialValue: undefined,
    type: 'string',
  },
  jobType: {
    initialValue: undefined,
    type: 'array',
  },
  worker: {
    initialValue: undefined,
    type: 'string',
  },
  isFreelance: {
    initialValue: undefined,
    type: 'boolean',
  },
  isTempWork: {
    initialValue: undefined,
    type: 'boolean',
  },
} as const;

export const useShiftPlanningPage = () => {
  const [params, setParams] = useExternalParams(initialValues);

  const filters: ShiftPlanningFilters = {
    fromDate: params.fromDate || undefined,
    company: params.company || undefined,
    branchOffices: params.branchOffices as string[] | undefined,
    departments: params.departments as string[] | undefined,
    filledStatus: (params.filledStatus as FilledStatus) ?? undefined,
    jobType: params.jobType as string[] | undefined,
    worker: params.worker || undefined,
    isFreelance: params.isFreelance || undefined,
    isTempWork: params.isTempWork || undefined,
  };
  const selectedFilterCount = Object.values(filters).filter((value) => {
    return value !== null && value !== undefined && value !== '';
  }).length;

  return {
    filters,
    setFilters: setParams,
    selectedFilterCount,
  };
};
